// extracted by mini-css-extract-plugin
module.exports = {"main_sec":"style_main_sec__19Qlf","left":"style_left__39nO9","right":"style_right__KH4X-","inner":"style_inner__2RBf-","main-img":"style_main-img__2xAmO"};